export default {
    difficulties: [
        {
            name: '2x2',
            rows: 2,
            columns: 2,
            level: 1,
        },
        {
            name: '2x3',
            rows: 2,
            columns: 3,
            level: 2,
        },
        {
            name: '3x3',
            rows: 3,
            columns: 3,
            level: 3,
        },
        {
            name: '3x4',
            rows: 3,
            columns: 4,
            level: 4,
        },
        {
            name: '4x4',
            rows: 4,
            columns: 4,
            level: 5,
        },
        {
            name: '5x5',
            rows: 5,
            columns: 5,
            level: 6,
        },
        {
            name: '6x6',
            rows: 6,
            columns: 6,
            level: 7,
        },
    ],
    colors: [
        {
            name: 'Green',
            value: '#71C372',
        },
        {
            name: 'Blue',
            value: '#4A9DFF',
        },
        {
            name: 'Orange',
            value: '#FF6230',
        },
        {
            name: 'Red',
            value: '#FF5050',
        },
        {
            name: 'Yellow',
            value: '#e5e527',
        },
        {
            name: 'Purple',
            value: '#c527c5',
        },
    ],
    maxAmountOfColors: 3,
};